const PUBLIC_PROPS_FIELD_NAME = '__publicProps__';

const props = function(clazz, methodName, descriptor) {
  !clazz[PUBLIC_PROPS_FIELD_NAME] && (clazz[PUBLIC_PROPS_FIELD_NAME] = []);
  clazz[PUBLIC_PROPS_FIELD_NAME].push(methodName);
  return descriptor;
};

/**
 * 获取公共的对外属性对
 * @return {object}
 */
const getProps = function(context) {
  const publicPropNames = context['__publicProps__'] || [];
  return publicPropNames.reduce((result, propName) => {
    result[propName] = context[propName];
    return result;
  }, {});
};

module.exports = {
  props,
  PUBLIC_PROPS_FIELD_NAME,
  getProps
};
